import React, { Component } from "react";

import "./App.css";
import AboutMe from "./AboutMe/AboutMe";
import Section from "./Section";

class App extends Component {
  render() {
    return (
      <div className="App">
        <Section>
          <AboutMe />
        </Section>
      </div>
    );
  }
}

export default App;
